import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'
const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/analysis',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'RedirectWrap',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Personal/PersonalCenter/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          title: t('router.personalCenter'),
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/helpDoc',
    component: Layout,
    name: 'HelpDoc',
    meta: {
      title: '帮助文档',
      hidden: true,
      icon: 'vi-material-symbols:book-outline'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/HelpDoc/HelpDoc.vue'),
        name: 'HelpDocIndex',
        meta: {
          title: '帮助文档',
          noCache: false,
          icon: 'vi-material-symbols:book-outline'
        }
      }
    ]
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/analysis',
    name: 'Dashboard',
    meta: {
      // title: t('router.dashboard'),
      // icon: 'vi-ant-design:dashboard-filled',
      // alwaysShow: true
    },
    children: [
      {
        path: 'analysis',
        component: () => import('@/views/Dashboard/Analysis.vue'),
        name: 'Analysis',
        meta: {
          title: t('router.analysis'),
          noCache: false,
          affix: true
        }
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: '/error/404',
    name: 'Error',
    meta: {
      title: t('router.errorPage'),
      icon: 'vi-ci:error',
      hidden: true
      // alwaysShow: true
    },
    children: [
      {
        path: '404',
        component: () => import('@/views/Error/404.vue'),
        name: '404Demo',
        meta: {
          title: '404'
        }
      },
      {
        path: '403',
        component: () => import('@/views/Error/403.vue'),
        name: '403Demo',
        meta: {
          title: '403'
        }
      },
      {
        path: '500',
        component: () => import('@/views/Error/500.vue'),
        name: '500Demo',
        meta: {
          title: '500'
        }
      }
    ]
  },
  {
    path: '/baseInfo',
    component: Layout,
    name: 'baseInfo',
    meta: {
      title: '基础信息',
      icon: 'vi-material-symbols:database-outline'
    },
    children: [
      {
        path: 'warehouse',
        component: () => import('@/views/BaseInfo/warehouse/warehouse.vue'),
        name: 'warehouse',
        meta: {
          title: '仓库基本信息',
          icon: 'vi-material-symbols:warehouse-outline',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/warehouse/warehouseAdd.vue'),
            name: 'warehouseAdd',
            meta: {
              title: '新增仓库',
              hidden: true,
              noCache: false,
              // noTagsView: true,
              activeMenu: '/baseInfo/warehouse'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/warehouse/warehouseEdit.vue'),
            name: 'warehouseEdit',
            meta: {
              title: '编辑仓库',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/warehouse'
            }
          },
          //详情
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/warehouse/warehouseDetail.vue'),
            name: 'warehouseDetail',
            meta: {
              title: '仓库详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/warehouse'
            }
          }
        ]
      },
      {
        path: 'customer',
        component: () => import('@/views/BaseInfo/customer/customer.vue'),
        name: 'customerIndex',
        meta: {
          title: '客户基本信息',
          icon: 'vi-material-symbols:groups-outline',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/customer/customerAdd.vue'),
            name: 'customerAdd',
            meta: {
              title: '新增客户信息',
              hidden: true,
              noCache: false,
              // noTagsView: true,
              activeMenu: '/baseInfo/customer'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/customer/customerEdit.vue'),
            name: 'customerEdit',
            meta: {
              title: '客户信息修改',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/customer'
            }
          },
          //详情
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/customer/customerDetail.vue'),
            name: 'customerDetail',
            meta: {
              title: '客户信息详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/customer'
            }
          }
        ]
      },
      // ✅ 拒单规则
      {
        path: 'rejectRule',
        component: () => import('@/views/BaseInfo/rejectRule/rejectRule.vue'),
        name: 'rejectRule',
        meta: {
          title: '拒单规则',
          icon: 'vi-ant-design:stop-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/rejectRule/rejectRuleAdd.vue'),
            name: 'rejectRuleAdd',
            meta: {
              title: '新增拒单规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/rejectRule'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/rejectRule/rejectRuleEdit.vue'),
            name: 'rejectRuleEdit',
            meta: {
              title: '编辑拒单规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/rejectRule'
            }
          },
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/rejectRule/rejectRuleDetail.vue'),
            name: 'rejectRuleDetail',
            meta: {
              title: '拒单规则详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/rejectRule'
            }
          }
        ]
      },

      // ✅ 大件规则
      {
        path: 'largeRule',
        component: () => import('@/views/BaseInfo/largeRule/largeRule.vue'),
        name: 'largeRule',
        meta: {
          title: '大件规则',
          icon: 'vi-ant-design:inbox-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/largeRule/largeRuleAdd.vue'),
            name: 'largeRuleAdd',
            meta: {
              title: '新增大件规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/largeRule'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/largeRule/largeRuleEdit.vue'),
            name: 'largeRuleEdit',
            meta: {
              title: '编辑大件规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/largeRule'
            }
          },
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/largeRule/largeRuleDetail.vue'),
            name: 'largeRuleDetail',
            meta: {
              title: '大件规则详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/largeRule'
            }
          }
        ]
      },

      // ✅ 运单号截断规则
      {
        path: 'waybillNumberTruncation',
        component: () =>
          import('@/views/BaseInfo/waybillNumberTruncation/waybillNumberTruncation.vue'),
        name: 'waybillNumberTruncation',
        meta: {
          title: '运单号截断规则',
          icon: 'vi-ant-design:barcode-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import('@/views/BaseInfo/waybillNumberTruncation/waybillNumberTruncationAdd.vue'),
            name: 'waybillNumberTruncationAdd',
            meta: {
              title: '新增运单号截断规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/waybillNumberTruncation'
            }
          },
          {
            path: 'edit',
            component: () =>
              import('@/views/BaseInfo/waybillNumberTruncation/waybillNumberTruncationEdit.vue'),
            name: 'waybillNumberTruncationEdit',
            meta: {
              title: '修改运单号截断规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/waybillNumberTruncation'
            }
          },
          {
            path: 'detail',
            component: () =>
              import('@/views/BaseInfo/waybillNumberTruncation/waybillNumberTruncationDetail.vue'),
            name: 'waybillNumberTruncationDetail',
            meta: {
              title: '运单号截断规则详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/waybillNumberTruncation'
            }
          }
        ]
      },

      // ✅ 特殊地区规则
      {
        path: 'specialAreaRule',
        component: () => import('@/views/BaseInfo/specialAreaRule/specialAreaRule.vue'),
        name: 'specialAreaRule',
        meta: {
          title: '特殊地区规则',
          icon: 'vi-ant-design:global-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/specialAreaRule/specialAreaRuleAdd.vue'),
            name: 'specialAreaRuleAdd',
            meta: {
              title: '新增特殊地区规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/specialAreaRule'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/specialAreaRule/specialAreaRuleEdit.vue'),
            name: 'specialAreaRuleEdit',
            meta: {
              title: '编辑特殊地区规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/specialAreaRule'
            }
          },
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/specialAreaRule/specialAreaRuleDetail.vue'),
            name: 'specialAreaRuleDetail',
            meta: {
              title: '特殊地区规则详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/specialAreaRule'
            }
          }
        ]
      },
      //质检模板
      {
        path: 'qcServiceTemplate',
        name: 'qcServiceTemplate',
        component: () => import('@/views/BaseInfo/qcServiceTemplate/qcServiceTemplate.vue'),
        meta: {
          title: '质检服务模板',
          icon: 'vi-ant-design:container-filled',
          noCache: false
        },
        children: [
          {
            path: 'add',
            name: 'qcServiceTemplateAdd',
            component: () => import('@/views/BaseInfo/qcServiceTemplate/qcServiceTemplateAdd.vue'),
            meta: {
              title: '新增质检服务模板',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/qcServiceTemplate'
            }
          },
          {
            path: 'edit',
            name: 'qcServiceTemplateEdit',
            component: () => import('@/views/BaseInfo/qcServiceTemplate/qcServiceTemplateEdit.vue'),
            meta: {
              title: '编辑质检服务模板',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/qcServiceTemplate'
            }
          },
          {
            path: 'detail',
            name: 'qcServiceTemplateDetail',
            component: () =>
              import('@/views/BaseInfo/qcServiceTemplate/qcServiceTemplateDetail.vue'),
            meta: {
              title: '质检服务模板详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/qcServiceTemplate'
            }
          }
        ]
      },
      //物流渠道
      {
        path: 'logisticsChannel',
        component: () => import('@/views/BaseInfo/logisticsChannel/logisticsChannel.vue'),
        name: 'logisticsChannel',
        meta: {
          title: '物流渠道基本信息',
          icon: 'mdi:truck-fast-outline',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/logisticsChannel/logisticsChannelAdd.vue'),
            name: 'logisticsChannelAdd',
            meta: {
              title: '新增渠道',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsChannel'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/logisticsChannel/logisticsChannelEdit.vue'),
            name: 'logisticsChannelEdit',
            meta: {
              title: '编辑渠道',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsChannel'
            }
          },
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/logisticsChannel/logisticsChannelDetail.vue'),
            name: 'logisticsChannelDetail',
            meta: {
              title: '渠道详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/logisticsChannel'
            }
          },
          {
            path: 'channelConfig',
            component: () => import('@/views/BaseInfo/logisticsChannel/channelConfig.vue'),
            name: 'channelConfig',
            meta: {
              title: '渠道配置',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsChannel'
            }
          },
          {
            path: 'channelMapConfig',
            name: 'channelMapConfig',
            component: () => import('@/views/BaseInfo/channelMapConfig/channelMapConfig.vue'),
            meta: {
              title: '渠道地址映射',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsChannel'
            },
            children: [
              {
                path: 'add',
                name: 'channelMapConfigAdd',
                component: () =>
                  import('@/views/BaseInfo/channelMapConfig/channelMapConfigAdd.vue'),
                meta: {
                  title: '新增渠道地址映射',
                  noCache: false,
                  hidden: true,
                  activeMenu: '/baseInfo/logisticsChannel'
                }
              },
              {
                path: 'edit',
                name: 'channelMapConfigEdit',
                component: () =>
                  import('@/views/BaseInfo/channelMapConfig/channelMapConfigEdit.vue'),
                meta: {
                  title: '编辑渠道地址映射',
                  noCache: false,
                  hidden: true,
                  activeMenu: '/baseInfo/logisticsChannel'
                }
              },
              {
                path: 'detail',
                name: 'channelMapConfigDetail',
                component: () =>
                  import('@/views/BaseInfo/channelMapConfig/channelMapConfigDetail.vue'),
                meta: {
                  title: '渠道地址映射详情',
                  noCache: true,
                  hidden: true,
                  activeMenu: '/baseInfo/logisticsChannel'
                }
              }
            ]
          }
        ]
      },
      //物流产品
      {
        path: 'logisticsProduct',
        component: () => import('@/views/BaseInfo/logisticsProduct/logisticsProduct.vue'),
        name: 'logisticsProduct',
        meta: {
          title: '物流商产品基本信息',
          icon: 'mdi:truck-fast-outline',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/BaseInfo/logisticsProduct/logisticsProductAdd.vue'),
            name: 'logisticsProductAdd',
            meta: {
              title: '新增物流商产品',
              hidden: true,
              // noCache: false,
              activeMenu: '/baseInfo/logisticsProduct'
            }
          },
          {
            path: 'edit',
            component: () => import('@/views/BaseInfo/logisticsProduct/logisticsProductEdit.vue'),
            name: 'logisticsProductEdit',
            meta: {
              title: '编辑物流商产品',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsProduct'
            }
          },
          {
            path: 'detail',
            component: () => import('@/views/BaseInfo/logisticsProduct/logisticsProductDetail.vue'),
            name: 'logisticsProductDetail',
            meta: {
              title: '物流商产品详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/logisticsProduct'
            }
          },
          {
            path: 'logisticsParams',
            component: () => import('@/views/BaseInfo/logisticsProduct/logisticsParams.vue'),
            name: 'logisticsParams',
            meta: {
              title: '物流对接参数',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsProduct'
            }
          },
          {
            path: 'trajectoryMapping',
            name: 'trajectoryMapping',
            component: () => import('@/views/BaseInfo/trajectoryMapping/trajectoryMapping.vue'),
            meta: {
              title: '轨迹映射',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticsProduct'
            },
            children: [
              {
                path: 'add',
                name: 'trajectoryMappingAdd',
                component: () =>
                  import('@/views/BaseInfo/trajectoryMapping/trajectoryMappingAdd.vue'),
                meta: {
                  title: '新增轨迹映射',
                  noCache: false,
                  hidden: true,
                  activeMenu: '/baseInfo/logisticsProduct'
                }
              },
              {
                path: 'edit',
                name: 'trajectoryMappingEdit',
                component: () =>
                  import('@/views/BaseInfo/trajectoryMapping/trajectoryMappingEdit.vue'),
                meta: {
                  title: '编辑轨迹映射',
                  noCache: false,
                  hidden: true,
                  activeMenu: '/baseInfo/logisticsProduct'
                }
              },
              {
                path: 'detail',
                name: 'trajectoryMappingDetail',
                component: () =>
                  import('@/views/BaseInfo/trajectoryMapping/trajectoryMappingDetail.vue'),
                meta: {
                  title: '轨迹映射详情',
                  noCache: true,
                  hidden: true,
                  activeMenu: '/baseInfo/logisticsProduct'
                }
              }
            ]
          }
        ]
      },
      //物流商产品路由规则
      {
        path: 'logisticProductRule',
        name: 'logisticProductRule',
        component: () => import('@/views/BaseInfo/logisticProductRule/logisticProductRule.vue'),
        meta: {
          title: '物流商产品路由规则',
          icon: 'mdi:truck-fast-outline'
        },
        children: [
          {
            path: 'add',
            name: 'logisticProductRuleAdd',
            component: () =>
              import('@/views/BaseInfo/logisticProductRule/logisticProductRuleAdd.vue'),
            meta: {
              title: '新增路由规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticProductRule'
            }
          },
          {
            path: 'edit',
            name: 'logisticProductRuleEdit',
            component: () =>
              import('@/views/BaseInfo/logisticProductRule/logisticProductRuleEdit.vue'),
            meta: {
              title: '编辑路由规则',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/logisticProductRule'
            }
          },
          {
            path: 'detail',
            name: 'logisticProductRuleDetail',
            component: () =>
              import('@/views/BaseInfo/logisticProductRule/logisticProductRuleDetail.vue'),
            meta: {
              title: '路由规则详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/logisticProductRule'
            }
          }
        ]
      },
      // 客户服务配置
      {
        path: 'customerServiceConfig',
        component: () => import('@/views/BaseInfo/customerServiceConfig/customerServiceConfig.vue'),
        name: 'customerServiceConfig',
        meta: {
          title: '客户服务配置',
          icon: 'mdi:account-cog',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import('@/views/BaseInfo/customerServiceConfig/customerServiceConfigAdd.vue'),
            name: 'customerServiceConfigAdd',
            meta: {
              title: '新增客户服务配置',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/customerServiceConfig'
            }
          },
          {
            path: 'edit',
            component: () =>
              import('@/views/BaseInfo/customerServiceConfig/customerServiceConfigEdit.vue'),
            name: 'customerServiceConfigEdit',
            meta: {
              title: '编辑客户服务配置',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/customerServiceConfig'
            }
          },
          {
            path: 'detail',
            component: () =>
              import('@/views/BaseInfo/customerServiceConfig/customerServiceConfigDetail.vue'),
            name: 'customerServiceConfigDetail',
            meta: {
              title: '客户服务配置详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/customerServiceConfig'
            }
          }
        ]
      },
      {
        path: 'warehouseNetworkMappingSetup',
        component: () =>
          import('@/views/BaseInfo/warehouseNetworkMappingSetup/warehouseNetworkMappingSetup.vue'),
        name: 'warehouseNetworkMappingSetup',
        meta: {
          title: '仓网映射关系配置',
          icon: 'vi-ant-design:apartment-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import(
                '@/views/BaseInfo/warehouseNetworkMappingSetup/warehouseNetworkMappingSetupAdd.vue'
              ),
            name: 'warehouseNetworkMappingSetupAdd',
            meta: {
              title: '新增仓网映射关系',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/warehouseNetworkMappingSetup'
            }
          },
          {
            path: 'edit',
            component: () =>
              import(
                '@/views/BaseInfo/warehouseNetworkMappingSetup/warehouseNetworkMappingSetupEdit.vue'
              ),
            name: 'warehouseNetworkMappingSetupEdit',
            meta: {
              title: '修改仓网映射关系',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/warehouseNetworkMappingSetup'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/BaseInfo/warehouseNetworkMappingSetup/warehouseNetworkMappingSetupDetail.vue'
              ),
            name: 'warehouseNetworkMappingSetupDetail',
            meta: {
              title: '仓网映射关系详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/warehouseNetworkMappingSetup'
            }
          }
        ]
      },
      // 仓网路由配置
      {
        path: 'warehouseNetworkRoutingConfiguration',
        component: () =>
          import(
            '@/views/BaseInfo/warehouseNetworkRoutingConfiguration/warehouseNetworkRoutingConfiguration.vue'
          ),
        name: 'warehouseNetworkRoutingConfiguration',
        meta: {
          title: '仓网路由配置',
          icon: 'vi-ant-design:branches-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import(
                '@/views/BaseInfo/warehouseNetworkRoutingConfiguration/warehouseNetworkRoutingConfigurationAdd.vue'
              ),
            name: 'warehouseNetworkRoutingConfigurationAdd',
            meta: {
              title: '新增仓网路由配置',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/warehouseNetworkRoutingConfiguration'
            }
          },
          {
            path: 'edit',
            component: () =>
              import(
                '@/views/BaseInfo/warehouseNetworkRoutingConfiguration/warehouseNetworkRoutingConfigurationEdit.vue'
              ),
            name: 'warehouseNetworkRoutingConfigurationEdit',
            meta: {
              title: '修改仓网路由配置',
              hidden: true,
              noCache: false,
              activeMenu: '/baseInfo/warehouseNetworkRoutingConfiguration'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/BaseInfo/warehouseNetworkRoutingConfiguration/warehouseNetworkRoutingConfigurationDetail.vue'
              ),
            name: 'warehouseNetworkRoutingConfigurationDetail',
            meta: {
              title: '仓网路由配置详情',
              hidden: true,
              noCache: true,
              activeMenu: '/baseInfo/warehouseNetworkRoutingConfiguration'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/goodsManage',
    component: Layout,
    name: 'goodsManage',
    meta: {
      title: '货品管理',
      icon: 'vi-solar:box-minimalistic-outline'
    },
    children: [
      {
        path: 'goodsInfo',
        component: () => import('@/views/GoodsManage/GoodsInfo/goodsInfo.vue'),
        name: 'GoodsInfo',
        meta: {
          title: '货品信息',
          icon: 'vi-material-symbols:inventory-2-outline',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () => import('@/views/GoodsManage/GoodsInfo/goodsInfoDetail.vue'),
            name: 'GoodsInfoDetail',
            meta: {
              title: '货品详情',
              hidden: true,
              noCache: true,
              activeMenu: '/goodsManage/goodsInfo'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/inventoryManagement',
    component: Layout,
    name: 'inventoryManagement',
    meta: {
      title: '库存管理',
      icon: 'vi-material-symbols:inventory-2-outline',
      alwaysShow: true
    },
    children: [
      {
        path: 'stockInfo',
        component: () => import('@/views/inventoryManagement/StockInfo/StockInfo.vue'),
        name: 'StockInfo',
        meta: {
          title: '货品库存',
          icon: 'vi-material-symbols:inventory-2-outline',
          noCache: false
        }
      },
      {
        path: 'historyStock',
        component: () => import('@/views/inventoryManagement/HistoryStock/HistoryStock.vue'),
        name: 'HistoryStock',
        meta: {
          title: '历史库存',
          icon: 'vi-ep:calendar',
          noCache: false
        }
      },
      {
        path: 'inventoryFlow',
        component: () => import('@/views/inventoryManagement/InventoryFlow/InventoryFlow.vue'),
        name: 'InventoryFlow',
        meta: {
          title: '库存流水',
          icon: 'vi-material-symbols:receipt-long-outline',
          noCache: false
        }
      }
    ]
  },
  {
    path: '/crossBorderFulfillmentOperations',
    component: Layout,
    name: 'crossBorderFulfillmentOperations',
    meta: {
      title: '跨境履约管理',
      icon: 'vi-ant-design:global-outlined',
      alwaysShow: true
    },
    children: [
      {
        path: 'warehouseShiftHandover',
        component: () =>
          import(
            '@/views/crossBorderFulfillmentOperations/warehouseShiftHandover/warehouseShiftHandover.vue'
          ),
        name: 'warehouseShiftHandover',
        meta: {
          title: '仓干交接',
          icon: 'vi-ant-design:swap-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/warehouseShiftHandover/warehouseShiftHandoverAdd.vue'
              ),
            name: 'warehouseShiftHandoverAdd',
            meta: {
              title: '新增仓干交接单',
              hidden: true,
              noCache: false,
              activeMenu: '/crossBorderFulfillmentOperations/warehouseShiftHandover'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/warehouseShiftHandover/warehouseShiftHandoverDetail.vue'
              ),
            name: 'warehouseShiftHandoverDetail',
            meta: {
              title: '仓干交接单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/crossBorderFulfillmentOperations/warehouseShiftHandover'
            }
          }
        ]
      },
      {
        path: 'linehaulLogistics',
        component: () =>
          import(
            '@/views/crossBorderFulfillmentOperations/linehaulLogistics/linehaulLogistics.vue'
          ),
        name: 'linehaulLogistics',
        meta: {
          title: '干线运输',
          icon: 'vi-mdi:truck-cargo-container',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/linehaulLogistics/linehaulLogisticsAdd.vue'
              ),
            name: 'linehaulLogisticsAdd',
            meta: {
              title: '新增干线运输单',
              hidden: true,
              noCache: false,
              activeMenu: '/crossBorderFulfillmentOperations/linehaulLogistics'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/linehaulLogistics/linehaulLogisticsDetail.vue'
              ),
            name: 'linehaulLogisticsDetail',
            meta: {
              title: '干线运输单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/crossBorderFulfillmentOperations/linehaulLogistics'
            }
          }
        ]
      },
      {
        path: 'transitWarehouse',
        component: () =>
          import('@/views/crossBorderFulfillmentOperations/transitWarehouse/transitWarehouse.vue'),
        name: 'transitWarehouse',
        meta: {
          title: '中转仓',
          icon: 'vi-mdi:warehouse',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/transitWarehouse/transitWarehouseDetail.vue'
              ),
            name: 'transitWarehouseDetail',
            meta: {
              title: '中转仓订单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/crossBorderFulfillmentOperations/transitWarehouse'
            }
          }
        ]
      },
      {
        path: 'customsClearance',
        component: () =>
          import('@/views/crossBorderFulfillmentOperations/customsClearance/customsClearance.vue'),
        name: 'customsClearance',
        meta: {
          title: '进口清关',
          icon: 'vi-mdi:file-document-check-outline',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/customsClearance/customsClearanceAdd.vue'
              ),
            name: 'customsClearanceAdd',
            meta: {
              title: '新增进口清关单',
              hidden: true,
              noCache: false,
              activeMenu: '/crossBorderFulfillmentOperations/customsClearance'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/customsClearance/customsClearanceDetail.vue'
              ),
            name: 'customsClearanceDetail',
            meta: {
              title: '进口清关单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/crossBorderFulfillmentOperations/customsClearance'
            }
          }
        ]
      },
      {
        path: 'domesticWarehouse',
        component: () =>
          import(
            '@/views/crossBorderFulfillmentOperations/domesticWarehouse/domesticWarehouse.vue'
          ),
        name: 'domesticWarehouse',
        meta: {
          title: '国内仓',
          icon: 'vi-mdi:home-city-outline',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/crossBorderFulfillmentOperations/domesticWarehouse/domesticWarehouseDetail.vue'
              ),
            name: 'domesticWarehouseDetail',
            meta: {
              title: '国内仓订单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/crossBorderFulfillmentOperations/domesticWarehouse'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/reverseOrderManage',
    component: Layout,
    name: 'reverseOrderManage',
    meta: {
      title: '逆向入库管理',
      icon: 'vi-icon-park-outline:transaction-order',
      alwaysShow: true
    },
    children: [
      {
        path: 'reverseWarehouseOrder',
        component: () =>
          import('@/views/ReverseOrderManage/reverseWarehouseOrder/ReverseOrder.vue'),
        name: 'reverseWarehouseOrder',
        meta: {
          title: '逆向入库单',
          icon: 'vi-ant-design:swap-outlined',
          noCache: false
        },
        children: [
          {
            path: 'edit',
            component: () =>
              import('@/views/ReverseOrderManage/reverseWarehouseOrder/ReverseOrderEdit.vue'),
            name: 'ReverseOrderEdit',
            meta: {
              title: '编辑逆向入库单',
              hidden: true,
              noCache: false,
              activeMenu: '/reverseOrderManage/reverseWarehouseOrder'
            }
          },
          {
            path: 'detail',
            component: () =>
              import('@/views/ReverseOrderManage/reverseWarehouseOrder/ReverseOrderDetail.vue'),
            name: 'ReverseOrderDetail',
            meta: {
              title: '逆向入库单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/reverseWarehouseOrder'
            }
          }
        ]
      },
      {
        path: 'reverseDeliveryOnlyOrder',
        component: () =>
          import(
            '@/views/ReverseOrderManage/reverseDeliveryOnlyOrder/reverseDeliveryOnlyOrder.vue'
          ),
        name: 'reverseDeliveryOnlyOrder',
        meta: {
          title: '逆向纯配订单',
          icon: 'vi-icon-park-outline:transaction-order',
          noCache: false
        },
        children: [
          {
            path: 'edit',
            component: () =>
              import(
                '@/views/ReverseOrderManage/reverseDeliveryOnlyOrder/reverseDeliveryOnlyOrderEdit.vue'
              ),
            name: 'reverseDeliveryOnlyOrderEdit',
            meta: {
              title: '编辑逆向纯配单',
              hidden: true,
              noCache: false,
              activeMenu: '/reverseOrderManage/reverseDeliveryOnlyOrder'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/ReverseOrderManage/reverseDeliveryOnlyOrder/reverseDeliveryOnlyOrderDetail.vue'
              ),
            name: 'reverseDeliveryOnlyOrderDetail',
            meta: {
              title: '逆向纯配单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/reverseDeliveryOnlyOrder'
            }
          }
        ]
      },
      {
        path: 'pickupAppointment',
        component: () =>
          import('@/views/ReverseOrderManage/pickupAppointment/pickupAppointment.vue'),
        name: 'pickupAppointment',
        meta: {
          title: '预约提货',
          icon: 'vi-mdi:calendar-clock',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import('@/views/ReverseOrderManage/pickupAppointment/pickupAppointmentAdd.vue'),
            name: 'pickupAppointmentAdd',
            meta: {
              title: '新增线下预约单',
              hidden: true,
              noCache: false,
              activeMenu: '/reverseOrderManage/pickupAppointment'
            }
          },
          {
            path: 'detail',
            component: () =>
              import('@/views/ReverseOrderManage/pickupAppointment/pickupAppointmentDetail.vue'),
            name: 'pickupAppointmentDetail',
            meta: {
              title: '预约单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/pickupAppointment'
            }
          }
        ]
      },
      {
        path: 'returnToSupplierOutbound',
        component: () =>
          import(
            '@/views/ReverseOrderManage/returnToSupplierOutbound/returnToSupplierOutbound.vue'
          ),
        name: 'returnToSupplierOutbound',
        meta: {
          title: '退供出库单',
          icon: 'vi-ant-design:rollback-outlined',
          noCache: false
        },
        children: [
          {
            path: 'add',
            component: () =>
              import(
                '@/views/ReverseOrderManage/returnToSupplierOutbound/returnToSupplierOutboundAdd.vue'
              ),
            name: 'returnToSupplierOutboundAdd',
            meta: {
              title: '新增退供出库单',
              hidden: true,
              noCache: false,
              activeMenu: '/reverseOrderManage/returnToSupplierOutbound'
            }
          },
          {
            path: 'edit',
            component: () =>
              import(
                '@/views/ReverseOrderManage/returnToSupplierOutbound/returnToSupplierOutboundEdit.vue'
              ),
            name: 'returnToSupplierOutboundEdit',
            meta: {
              title: '修改退供出库单',
              hidden: true,
              noCache: false,
              activeMenu: '/reverseOrderManage/returnToSupplierOutbound'
            }
          },
          {
            path: 'detail',
            component: () =>
              import(
                '@/views/ReverseOrderManage/returnToSupplierOutbound/returnToSupplierOutboundDetail.vue'
              ),
            name: 'returnToSupplierOutboundDetail',
            meta: {
              title: '退供出库单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/returnToSupplierOutbound'
            }
          }
        ]
      },
      //退供出库  Return-to-supplier outbound

      {
        path: 'receiveRecord',
        component: () => import('@/views/ReverseOrderManage/receiveRecord/receiveRecord.vue'),
        name: 'receiveRecord',
        meta: {
          title: '收包记录',
          icon: 'vi-ep:takeaway-box',
          noCache: false
        }
      },
      {
        path: 'checkRecord',
        component: () => import('@/views/ReverseOrderManage/checkRecord/checkRecord.vue'),
        name: 'checkRecord',
        meta: {
          title: '查验记录',
          icon: 'vi-ep:view',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () => import('@/views/ReverseOrderManage/checkRecord/checkRecordDetail.vue'),
            name: 'checkRecordDetail',
            meta: {
              title: '验货记录详情',
              hidden: true,
              noCache: true
            }
          }
        ]
      },
      //取消件记录
      {
        path: 'canceledRecord',
        component: () => import('@/views/ReverseOrderManage/canceledRecord/canceledRecord.vue'),
        name: 'canceledRecord',
        meta: {
          title: '取消件记录',
          icon: 'vi-ep:circle-close',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () =>
              import('@/views/ReverseOrderManage/canceledRecord/canceledRecordDetail.vue'),
            name: 'canceledRecordDetail',
            meta: {
              title: '取消件记录详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/canceledRecord'
            }
          }
        ]
      },
      //无主件记录
      {
        path: 'unclaimedRecord',
        component: () => import('@/views/ReverseOrderManage/unclaimedRecord/unclaimedRecord.vue'),
        name: 'unclaimedRecord',
        meta: {
          title: '无主件记录',
          icon: 'vi-ep:warning',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () =>
              import('@/views/ReverseOrderManage/unclaimedRecord/unclaimedRecordDetail.vue'),
            name: 'unclaimedRecordDetail',
            meta: {
              title: '无主件记录详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/unclaimedRecord'
            }
          }
        ]
      },
      //换单列表
      {
        path: 'orderChangeRecord',
        component: () =>
          import('@/views/ReverseOrderManage/orderChangeRecord/orderChangeRecord.vue'),
        name: 'orderChangeRecord',
        meta: {
          title: '换单列表',
          icon: 'vi-ep:refresh-right',
          noCache: false
        },
        children: [
          {
            path: 'detail',
            component: () =>
              import('@/views/ReverseOrderManage/orderChangeRecord/orderChangeRecordDetail.vue'),
            name: 'orderChangeRecordDetail',
            meta: {
              title: '换单详情',
              hidden: true,
              noCache: true,
              activeMenu: '/reverseOrderManage/orderChangeRecord'
            }
          }
        ]
      },
      //换标记录
      {
        path: 'labelChangeRecord',
        component: () =>
          import('@/views/ReverseOrderManage/labelChangeRecord/labelChangeRecord.vue'),
        name: 'labelChangeRecord',
        meta: {
          title: '换标记录',
          icon: 'vi-ep:price-tag',
          noCache: false
        }
      }
    ]
  }
]
const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
